import {
  provideZoneChangeDetection,
  LOCALE_ID,
  importProvidersFrom,
} from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeEn from '@angular/common/locales/en';
import localeIt from '@angular/common/locales/it';
// import localeJa from '@angular/common/locales/ja'; // disabled: it/en-only release (see language.service.ts)

import { environment } from './environments/environment';

// Angular only bundles en-US locale data by default. LOCALE_ID is 'it-IT' and
// LocalizedDatePipe builds DatePipe('it'|'en') from the active language, so
// without registering these the date pipes throw "Missing locale data" — which the
// language service hits on first load for any it browser. Register the languages
// LanguageService offers. (localeJa is commented out for the it/en-only release.)
registerLocaleData(localeEn);
registerLocaleData(localeIt);
// registerLocaleData(localeJa);
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_LUXON_DATE_ADAPTER_OPTIONS } from '@angular/material-luxon-adapter';
import { FORMLY_CONFIG, FormlyModule } from '@ngx-formly/core';
import { DATETIMEPICKER_USE_NATIVE } from '@rg/shared-ng';
import { formlyConfig } from './app/formly-config';
import {
  TranslateService,
  provideTranslateService,
  TranslateModule,
} from '@ngx-translate/core';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { routes } from './app/app.routes';
import { ReactiveFormsModule } from '@angular/forms';
import { FormlyMaterialModule } from '@ngx-formly/material';
import { AppComponent } from './app/app.component';
import { initDeepLinkCapture } from './app/deep-link';

// Start capturing deep links BEFORE bootstrap: a cold-start Universal/App Link is
// delivered during launch, so a listener attached only inside a component would
// miss it. initDeepLinkCapture() buffers the URL for AppComponent to consume.
initDeepLinkCapture();

if (!environment.enableDebug) {
  // Strip non-essential console output in production builds. Keep warn/error.
  const noop = () => {};
  (console as any).log = noop;
  (console as any).debug = noop;
  (console as any).info = noop;
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    provideRouter(routes),
    importProvidersFrom(
      TranslateModule.forRoot(),
      FormlyModule.forRoot(),
      ReactiveFormsModule,
      FormlyMaterialModule
    ),
    provideAnimationsAsync(),
    { provide: LOCALE_ID, useValue: 'it-IT' },
    { provide: MAT_DATE_LOCALE, useValue: 'it-IT' },
    { provide: MAT_LUXON_DATE_ADAPTER_OPTIONS, useValue: { useUtc: false } },
    // The shared datetimepicker defaults to a Material picker (admin + website);
    // on this Capacitor app keep the native OS date/time wheel for touch UX.
    { provide: DATETIMEPICKER_USE_NATIVE, useValue: true },
    {
      provide: FORMLY_CONFIG,
      multi: true,
      useFactory: formlyConfig,
      deps: [TranslateService],
    },
    provideHttpClient(withInterceptorsFromDi()),
    provideTranslateService({
      loader: provideTranslateHttpLoader(),
    }),
  ],
}).catch((err) => console.error(err));
